import * as types from './types'

export default {
  [types.RESET_SURVEY] (state) {
    state.survey = []
  },
  [types.SET_SURVEY] (state, data) {
    state.survey = data.audit
    state.surveyDetails = data.auditDetails
  },
  [types.SET_SURVEYS] (state, surveys) {
    state.surveys = surveys || []
  },
  [types.SET_SURVEY_TYPES] (state, surveyTypes) {
    state.surveyTypes = surveyTypes
  },
  [types.SET_INCOMPLETE_SURVEYS_COUNT] (state, count) {
    state.incompleteSurveysCount = count
  },
  [types.ADD_PHOTO] (state, { questionId, filename }) {
    state.survey.filter((x) => x.question.id === questionId)[0].answer.photos.push(filename)
  },
  [types.REMOVE_PHOTO] (state, { questionId, filename }) {
    state.survey
      .filter((x) => x.question.id === questionId)[0]
      .answer.photos.splice(
        state.survey.filter((x) => x.question.id === questionId)[0].answer.photos.indexOf(filename),
        1
      )
  },
  [types.UPDATE_INCOMPLETE_SURVEYS_COUNT] (state, count) {
    state.incompleteSurveysCount += count
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/survey/mutations.js